export const addPrimaryCtaSx = {
  textTransform: 'none',
  borderRadius: '999px',
  minHeight: 36,
  px: 2.25,
  fontWeight: 800,
  backgroundColor: '#FCB402',
  color: 'white',
  '&:hover': { backgroundColor: '#E9A900' },
}

export const addPrimaryFabSx = {
  borderRadius: '999px',
  minHeight: 36,
  height: 36,
  px: 2.25,
  textTransform: 'none',
  fontWeight: 800,
  backgroundColor: '#FCB402',
  color: 'white',
  boxShadow: 'none',
  '&:hover': { backgroundColor: '#E9A900', boxShadow: 'none' },
}

export const addSecondaryFabSx = {
  borderRadius: '999px',
  minHeight: 36,
  height: 36,
  px: 2.1,
  textTransform: 'none',
  fontWeight: 700,
  backgroundColor: '#FFFFFF',
  color: '#203864',
  border: '1px solid rgba(32, 56, 100, 0.24)',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: 'rgba(32, 56, 100, 0.04)',
    borderColor: 'rgba(32, 56, 100, 0.36)',
    boxShadow: 'none',
  },
}
